import { Typography } from 'src/components/PulseUI';
import React from 'react';

interface NumericalHeaderProps {
  field?: string;
  colDef?: {
    headerName?: string;
  };
  [key: string]: any;
}

const NumericalHeader: React.FC<NumericalHeaderProps> = (props) => {
  return (
    <div className="w-full flex justify-end">
      <Typography variant="subtitle2" className="font-medium">
        {props?.colDef?.headerName}
      </Typography>
    </div>
  );
};

export default NumericalHeader;